import { jsx as L, jsxs as t } from "react/jsx-runtime";
import "react";
var i = (l) => /* @__PURE__ */ t("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ L("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ L("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-454 -900)",
      fill: "white"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#496E2D"
    }),
    /* @__PURE__ */ L("path", {
      d: "M15.9305 5.7624C16.4226 4.391 15.8698 2.89959 14.6836 2.15674C14.897 2.18451 15.1105 2.23475 15.3214 2.31033C16.9036 2.87799 17.726 4.62068 17.1583 6.20287C16.5907 7.7851 14.848 8.60748 13.2658 8.03982C13.055 7.9642 12.8581 7.86713 12.6758 7.75295C14.0637 7.93361 15.4386 7.13377 15.9305 5.7624Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M13.2012 1.78076L12.7737 2.33314L12.1163 2.09729L12.5095 2.67455L12.082 3.22689L12.7525 3.03135L13.1458 3.60854L13.167 2.91041L13.8375 2.71482L13.1801 2.479L13.2012 1.78076Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M14.3555 3.58081L13.928 4.13319L13.2706 3.89729L13.6639 4.4746L13.2363 5.02694L13.9069 4.83132L14.3002 5.40862L14.3213 4.71046L14.9919 4.51487L14.3344 4.27897L14.3555 3.58081Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M11.1661 2.4364L10.7386 2.98875L10.0811 2.75289L10.4744 3.33015L10.0469 3.8825L10.7174 3.68695L11.1107 4.26421L11.1318 3.56605L11.8023 3.37046L11.145 3.13457L11.1661 2.4364Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M11.1192 4.49817L10.6917 5.05059L10.0343 4.81469L10.4275 5.39196L10 5.9443L10.6705 5.74876L11.0638 6.32602L11.085 5.62782L11.7555 5.43227L11.098 5.19637L11.1192 4.49817Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M13.0821 5.20215L12.6546 5.75453L11.9971 5.51863L12.3904 6.0959L11.9629 6.64824L12.6335 6.4527L13.0267 7.02996L13.0479 6.33176L13.7184 6.13617L13.0609 5.90031L13.0821 5.20215Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M6.84824 0H1.63086V20H6.84824V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ L("path", {
      d: "M3.62156 5.26502L2.74805 4.61432V3.69416L3.62156 3.04346H4.85691L5.73043 3.69416V4.61432L4.85691 5.26502H3.62156Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M4.23922 3.04346H3.62156L2.74805 3.69416V4.144H4.23922V3.04346Z",
      fill: "#FF9811"
    }),
    /* @__PURE__ */ L("path", {
      d: "M4.23828 5.26498H4.85598L5.72949 4.61427V4.1449H4.23828V5.26498Z",
      fill: "#FF9811"
    }),
    /* @__PURE__ */ L("path", {
      d: "M3.62156 16.9567L2.74805 16.306V15.3858L3.62156 14.7351H4.85691L5.73043 15.3858V16.306L4.85691 16.9567H3.62156Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M4.23922 14.7351H3.62156L2.74805 15.3858V15.8357H4.23922V14.7351Z",
      fill: "#FF9811"
    }),
    /* @__PURE__ */ L("path", {
      d: "M4.23828 16.9567H4.85598L5.72949 16.306V15.8365H4.23828V16.9567Z",
      fill: "#FF9811"
    }),
    /* @__PURE__ */ L("path", {
      d: "M3.62156 11.1109L2.74805 10.4602V9.54002L3.62156 8.88928H4.85691L5.73043 9.54002V10.4602L4.85691 11.1109H3.62156Z",
      fill: "#496E2D"
    }),
    /* @__PURE__ */ L("path", {
      d: "M5.76035 12.5425H5.37988V12.1621H4.71129L4.23852 11.6893L3.76582 12.1621H3.09727V12.5425H2.7168V13.3034H3.09727V13.6839H3.76578L4.23855 14.1566L4.71129 13.6839H5.37988V13.3034H5.76035V12.5425Z",
      fill: "#496E2D"
    }),
    /* @__PURE__ */ L("path", {
      d: "M5.76035 6.69659H5.37988V6.31616H4.71129L4.23852 5.84338L3.76582 6.31616H3.09727V6.69659H2.7168V7.45749H3.09727V7.83792H3.76578L4.23855 8.31069L4.71129 7.83792H5.37988V7.45749H5.76035V6.69659Z",
      fill: "#496E2D"
    }),
    /* @__PURE__ */ L("path", {
      d: "M4.67426 9.56519H3.80469V10.4348H4.67426V9.56519Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ L("path", {
      d: "M4.23945 7.51174C4.47957 7.51174 4.67422 7.31709 4.67422 7.07698C4.67422 6.83686 4.47957 6.64221 4.23945 6.64221C3.99934 6.64221 3.80469 6.83686 3.80469 7.07698C3.80469 7.31709 3.99934 7.51174 4.23945 7.51174Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ L("path", {
      d: "M4.23945 13.3578C4.47957 13.3578 4.67422 13.1632 4.67422 12.923C4.67422 12.6829 4.47957 12.4883 4.23945 12.4883C3.99934 12.4883 3.80469 12.6829 3.80469 12.923C3.80469 13.1632 3.99934 13.3578 4.23945 13.3578Z",
      fill: "#D80027"
    })
  ]
});
export {
  i as default
};
